import request from '@/assets/scripts/utils/request';

// 成果库   行业分类
export function getIndustryList(params) {
    return request({
        url: '/science/getIndustryList',
        method: 'get',
        params
    });
}

// 成果库   技术领域
export function getTechnology(params) {
    return request({
        url: '/science/getTechnology',
        method: 'get',
        params
    });
}


// 合作方式
export function getCooperateType(params) {
    return request({
        url: '/science/getCooperateType',
        method: 'get',
        params
    });
}
// 成果库 成果列表
export function getAchievementList(params) {
    return request({
        url: '/science/getAchievementList',
        method: 'get',
        params
    });
}

// 成果库   成果类型
export function getAchieveType(params) {
    return request({
        url: '/science/getAchieveType',
        method: 'get',
        params
    });
}
// 发布或编辑成果
export function addOrEditAchievement(data) {
    return request({
        url: '/science/addOrEditAchievement',
        method: 'post',
        data
    });
}
// 成果详情
export function getAchievementDetail(params) {
    return request({
        url: '/science/getAchievementDetail',
        method: 'get',
        params
    });
}

// 人才库   学科领域
export function getSubList(params) {
    return request({
        url: '/scholar/getSubList',
        method: 'get',
        params
    });
}
// 人才库   专家头衔
export function getRankList(params) {
    return request({
        url: '/scholar/getRankList',
        method: 'get',
        params
    });
}
// 人才库   字母列表
export function getLetterList(params) {
    return request({
        url: '/scholar/getLetterList',
        method: 'get',
        params
    });
}

// 人才库   分类
export function getTalentPoolType(params) {
    return request({
        url: '/science/getTalentPoolType',
        method: 'get',
        params
    });
}
// 地区分类
export function getDistrictTree(params) {
    return request({
        url: '/science/getDistrictTree',
        method: 'get',
        params
    });
}
// 人才库    职称
export function getTitle(params) {
    return request({
        url: '/science/getTitle',
        method: 'get',
        params
    });
}
// 人才库   列表
export function getPersonnelList(params) {
    return request({
        url: '/scholar/getPersonnelList',
        method: 'get',
        params
    });
}

// 删除
export function delData(data) {
    return request({
        url: '/science/delData',
        method: 'post',
        data
    });
}


// 需求库   工作年限 、预算、教育学历
export function getConfigList(params) {
    return request({
        url: '/science/getConfigList',
        method: 'get',
        params
    });
}
// 需求库   科技需求列表
export function getTechnologyList(params) {
    return request({
        url: '/science/getTechnologyList',
        method: 'get',
        params
    });
}


// 需求库   服务需求列表
export function getServerList(params) {
    return request({
        url: '/science/getServerList',
        method: 'get',
        params
    });
}

// 需求库  人才需求列表
export function getTalentsList(params) {
    return request({
        url: '/science/getTalentsList',
        method: 'get',
        params
    });
}
// 添加联系方式
export function submitContactInfo(data) {
    return request({
        url: '/science/submitContactInfo',
        method: 'post',
        data
    });
}
// 需求库    技术需求详情
export function getTechnologyDetail(params) {
    return request({
        url: '/science/getTechnologyDetail',
        method: 'get',
        params
    });
}
// 需求库   服务需求详情
export function getServerDetail(params) {
    return request({
        url: '/science/getServerDetail',
        method: 'get',
        params
    });
}
// 需求库   人才需求详情
export function getTalentsDetail(params) {
    return request({
        url: '/science/getTalentsDetail',
        method: 'get',
        params
    });
}
// 需求库   添加或编辑人才需求
export function addOrEditTalents(data) {
    return request({
        url: '/science/addOrEditTalents',
        method: 'post',
        data
    });
}
// 需求库    添加或编辑技术需求
export function addOrEditTechnology(data) {
    return request({
        url: '/science/addOrEditTechnology',
        method: 'post',
        data
    });
}
// 需求库   添加或编辑服务需求
export function addOrEditServe(data) {
    return request({
        url: '/science/addOrEditServe',
        method: 'post',
        data
    });
}

// 专家详情
export function getExpertDetail(params) {
    return request({
        url: '/science/getExpertDetail',
        method: 'get',
        params
    });
}

// 服务形式列表
export function getFormList(params) {
    return request({
        url: '/science/getFormList',
        method: 'get',
        params
    });
}

// 获取编辑需求时候的数据
export function getDemandInfo(params) {
    return request({
        url: '/science/demandInfo',
        method: 'get',
        params
    });
}

// 获取编辑成果时候的数据
export function getAchievementInfo(params) {
    return request({
        url: '/science/achievementInfo',
        method: 'get',
        params
    });
}